import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import GroupItem from '../../Groups/GroupItem'
import usePrintSalesBySegment from '../../hooks/usePrintSalesBySegment'
import ContentForm from './ContentForm'

export default function ModalCourtesiesLocalGuide() {
    const { isLoading, submit } = usePrintSalesBySegment()
    const { isOpen, onClose, onOpen } = useDisclosure()

    return (
        <>
            <GroupItem onClick={onOpen} label="Ventas Detallada por Segmento" />
            <Modal isOpen={isOpen} onClose={onClose} size="sm">
                <ModalOverlay />
                <ModalContent p={4} pb={6}>
                    <ModalHeader textAlign="center">
                        Reporte de Ventas Detallado por Segmento
                    </ModalHeader>
                    <ModalBody>
                        <ContentForm onSubmit={submit} isLoading={isLoading} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
